export enum UserRoles {
  Admin = 'admin',
  Moderator = 'moderator'
}
